import React from "react";
import { connect } from "react-redux";
import FullScreenModal from "../FullScreenModal";
import { FaCheckCircle, FaTimes, FaExclamationCircle } from "react-icons/fa";
import { appConstants } from "../../_constants";
import { modalActions } from "../../_actions";
import { Card, CardBody, Button } from "reactstrap";
import { appHelpers } from "../../_helpers";


const CustomActionAlert = ({ displayCustomActionAlert, handleActionClick, dispatch }) => {

  const action = displayCustomActionAlert.action;
  const actionButtonType = displayCustomActionAlert.actionButtonType;

  const icon = action === "success" ? (
    <FaCheckCircle size={100} color={appConstants.SUCCESS_COLOR} />
  ) :  action === "failure" ? (
    <FaTimes size={100} color={appConstants.DANGER_COLOR} />
  ) :  action === "info" ? (
    <FaExclamationCircle size={100} color={appConstants.WARNING_COLOR} />
  ) : null;
  const getButtonColor = () => {
    switch (displayCustomActionAlert.actionButtonType) {
      case "primary":
        return { style: "btn-primary", color: "primary",  };
      case "secondary":
        return { style: "btn-secondary", color: "secondary" };
      case "success":
        return { style: "btn-success text-white", color: "success" ,};
      case "danger":
      case "failure":
        return { style: "btn-danger", color: "danger" };
      case "warning":
        return { style: "btn-warning", color: "warning" };
      case "info":
        return { style: "btn-info", color: "info" };
      case "light":
        return { style: "btn-light", color: "light" };
      case "dark":
        return { style: "btn-dark", color: "dark" };
      default:
        return { style: "btn-success", color: "success" };
    }
  };
  

  return (
    <FullScreenModal
      show={displayCustomActionAlert.show}
      width={"35%"}
      callback={(res) => {
        appHelpers.fullScreenCallback.call(
          this,
          res,
          dispatch,
          displayCustomActionAlert,
          modalActions.displayCustomActionAlert({
            show: false,
          })
        );
      }}
    >
      <Card style={{ borderRadius: "10px", maxHeight: "70%", overflowY: "auto" }}>
        <CardBody className={"d-flex flex-column justify-content-center"} style={{ padding: "4rem 2rem" }}>
          <div>
            <p className={"text-center"}> {icon}</p>
            {displayCustomActionAlert.title? (
              <>
                <h3 style={{ fontWeight: "600", textAlign: "center" }}>{displayCustomActionAlert.title}</h3>
                <p style={{ color: "GrayText", textAlign: "center" }}>{displayCustomActionAlert.message}</p>
              </>
            ) : (
              <h3 style={{ fontWeight: "600", textAlign: "center" }}>{displayCustomActionAlert.message}</h3>
            )}
          </div>
          <div>
            {/* Action Button */}
            {displayCustomActionAlert.actionButtonText && (
              <div style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={handleActionClick}
                  className={`btn-rounded  px-4 ${getButtonColor().style}`}
                  color={getButtonColor().color ? getButtonColor().color : "success"}
                >
                  {displayCustomActionAlert.actionButtonText}
                </Button>
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    </FullScreenModal>
  );
};

const mapStateToProps = (state) => ({
  ...state,
});

export default connect(mapStateToProps)(CustomActionAlert);
